import { createI18n } from "vue-i18n";
import { STORAGE } from "@/shared/utils/storage";

import { isLocale, messages, type Locale, type MessageSchema } from "./messages";

export { LOCALES, isLocale, type Locale, type MessageSchema } from "./messages";

const FALLBACK_LOCALE: Locale = "en";

function loadLocale(): Locale {
	const stored = STORAGE.locale.read();
	if (isLocale(stored)) return stored;
	const browserLang = navigator.language.split("-")[0];
	return isLocale(browserLang) ? browserLang : FALLBACK_LOCALE;
}

const i18n = createI18n<{ message: MessageSchema }, Locale, false>({
	legacy: false,
	locale: loadLocale(),
	fallbackLocale: FALLBACK_LOCALE,
	messages,
});

export function setLocale(locale: Locale) {
	i18n.global.locale.value = locale;
	STORAGE.locale.write(locale);
}

export default i18n;
